import request from '@/utils/request'

export function getProductByCode(code, store) {
  return request({
    url: 'product/getProductByCode/' + code + '/' + store,
    method: 'get'
  });
}
